const userRouter = [
    {
        path: "list-rental_order",
        name: "list",
        component: () => import("@/views/admin/rental_order"),
        default: true,
        meta: {
            model: "rental_order_custom",
            // requiresAuth: true,
        },
    },
    {
        path: "list-rental_order/add",
        name: "add",
        component: () => import("@/views/admin/rental_order/function"),
        default: true,
        meta: {
            model: "rental_order_custom",
            // requiresAuth: true,
        },
    },
    {
        path: "list-rental_order/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/rental_order/function"),
        default: true,
        meta: {
            model: "rental_order_custom",
            // requiresAuth: true,
        },
    },
    {
        path: "list-rental_order/complete/:id",
        name: "edit",
        component: () => import("@/views/admin/rental_order/function_complete"),
        default: true,
        meta: {
            model: "rental_order_custom",
            // requiresAuth: true,
        },
    },
    {
        path: "list-rental_order/view/:id",
        name: "view",
        component: () => import("@/views/admin/rental_order/function"),
        default: true,
        meta: {
            model: "rental_order_custom",
            // requiresAuth: true,
        },
    },
];
export default userRouter;